import { combineDateAndTime } from '@/utils/time'
import { addDays, startOfDay } from 'date-fns'

export function startsAfterEnd(start: Date, end: Date, hourly: boolean) {
  if (hourly) return start >= end
  return startOfDay(start) > startOfDay(end)
}

export function withPickedDate(picked: Date, current: Date, hourly: boolean) {
  return hourly ? combineDateAndTime(picked, current) : picked
}

export function transformAbsenceDates(
  values: { datetimeStart: Date; datetimeEnd: Date },
  hourly: boolean
) {
  const datetimeStart = (
    hourly ? values.datetimeStart : startOfDay(values.datetimeStart)
  ).toISOString()

  const datetimeEnd = (
    hourly ? values.datetimeEnd : startOfDay(addDays(values.datetimeEnd, 1))
  ).toISOString()

  return {
    datetimeStart,
    datetimeEnd,
  }
}
